import React, { useState } from "react";
import LoaderButton from "./LoaderButton";

function Footer(props) {
  const [social, setSocial] = useState(false);
  return (
    <div style={{ paddingBottom: 40 }}>
      {social === false ? (
        <div style={{ borderStyle: "groove", height: 180, marginTop: -2 }}>
          <h3 style={{ marginTop: 40, marginLeft: 90, marginRight: 90 }}>
            Next, select real estate properties to generate your personal heat
            map.
          </h3>
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
          >
            <LoaderButton
              onClick={() =>
                window.open(
                  "https://chrome.google.com/webstore/category/extensions",
                  "_blank"
                )
              }
            >
              Download Widget
            </LoaderButton>
            <LoaderButton
              onClick={() => window.open("https://realtor.com", "_blank")}
            >
              Realtor.com
            </LoaderButton>
          </div>
          <a>
            Need help? See our detailed instruction for how to browse and
            bookmark properties.
          </a>
        </div>
      ) : (
        <div style={{ borderStyle: "groove", height: 180 }}>
          <h3 style={{ marginTop: 40, marginLeft: 90, marginRight: 90 }}>
            No properties selected. To browse and bookmark properties, download
            and install our Realtor.com Chrome Extension.
          </h3>
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 20 }}
          >
            <LoaderButton
              onClick={() =>
                window.open(
                  "https://chrome.google.com/webstore/category/extensions",
                  "_blank"
                )
              }
            >
              Download Widget
            </LoaderButton>
            <LoaderButton
              onClick={() => window.open("https://realtor.com", "_blank")}
            >
              Realtor.com
            </LoaderButton>
          </div>
        </div>
      )}
    </div>
  );
}

export default Footer;
